define('common/ko/fn/replacements',[
    'knockout',
    'underscore'
], function (ko, _) {

    ko.subscribable.fn.logger = ko.subscribable.fn.logger || ko.observable();

    /**
     * Use this to replace dynamic value placeholders in strings from the CMS
     *
     * The implementation uses code from ko.punches and supports the text binding syntax
     *
     * @param {Object} replacements
     *
     * @return {Subscribable}
     */
    ko.subscribable.fn.replacements = function (replacements) {

        var original = this;

        return ko.pureComputed(function () {

            // Excessively verbose name to avoid collisions in the eval below
            var replacementsReplaced = '';

            if (!_.isString(original())) {
                return '';
            }

            parseInterpolationMarkup(
                original().replace(/{{{/g, '{{').replace(/}}}/g, '}}'),
                function (outer) {
                    replacementsReplaced += outer;
                },
                function (inner) {

                    var innerExpressionWithFilters = ko.punches.textFilter.preprocessor(inner.trim());

                    try {
                        // jscs:disable disallowKeywords
                        // jshint withstmt: true
                        with (replacements) {
                            eval('replacementsReplaced += ko.unwrap(' + innerExpressionWithFilters + ')');
                        }
                    } catch (e) {

                        original.logger.waitForValue().then(function (LOG) {
                            LOG.error(e);
                        });

                    }
                }
            );

            return replacementsReplaced;

        });

    };

    /**
     * Copied from ko.punches.js with changes:
     *
     *  - Fix code style to pass linting
     *  - Extra else block commented below
     */
    function parseInterpolationMarkup(textToParse, outerTextCallback, expressionCallback) {

        var outerMatch;

        function innerParse(text) {

            var innerMatch = text.match(/^([\s\S]*)}}([\s\S]*?)\{\{([\s\S]*)$/);

            if (innerMatch) {
                innerParse(innerMatch[1]);
                outerTextCallback(innerMatch[2]);
                expressionCallback(innerMatch[3]);
            } else {
                expressionCallback(text);
            }
        }

        outerMatch = textToParse.match(/^([\s\S]*?)\{\{([\s\S]*)}}([\s\S]*)$/);

        if (outerMatch) {
            outerTextCallback(outerMatch[1]);
            innerParse(outerMatch[2]);
            outerTextCallback(outerMatch[3]);
        } else {
            // Added to handle cases where the text contains no placeholders
            outerTextCallback(textToParse);
        }
    }

});

